import { create } from 'zustand'

export const DISTRIBUTION_MODE_STORAGE_KEY = 'bookkeeper:distribution-mode'

export type DistributionMode = 'cash' | 'income'

interface DistributionModeState {
  mode: DistributionMode
  setMode: (mode: DistributionMode) => void
}

function loadMode(): DistributionMode {
  try {
    const raw = localStorage.getItem(DISTRIBUTION_MODE_STORAGE_KEY)
    if (raw === 'income' || raw === 'cash') return raw
  } catch {
    // Ignore storage errors (privacy mode, SSR).
  }
  return 'cash'
}

function persistMode(mode: DistributionMode): void {
  try {
    localStorage.setItem(DISTRIBUTION_MODE_STORAGE_KEY, mode)
  } catch {
    // Ignore storage errors.
  }
}

export const useDistributionModeStore = create<DistributionModeState>((set) => ({
  mode: loadMode(),
  setMode: (mode) => {
    persistMode(mode)
    set({ mode })
  },
}))
